// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconHardwareHardDriveError_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" class="svg-fg"/>
  <path d="M4.41773 4H19.5823L24 11.7836V13.75C23.4189 13.14 22.7325 12.6311 21.97 12.2525L21.7592 11.8873L18.4177 6H5.58227L2.17678 12H16.0989C15.0007 12.4317 14.0332 13.1237 13.2726 14H2V19H11.5042C11.5278 19.696 11.6495 20.3671 11.8559 21H0V11.7834L4.41773 4Z" class="svg-bg"/>
  <path d="M6 16.5C6 17.0523 5.55229 17.5 5 17.5C4.44772 17.5 4 17.0523 4 16.5C4 15.9477 4.44772 15.5 5 15.5C5.55229 15.5 6 15.9477 6 16.5Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M26.75 32C29.6495 32 32 29.6495 32 26.75C32 23.8505 29.6495 21.5 26.75 21.5C23.8505 21.5 21.5 23.8505 21.5 26.75C21.5 29.6495 23.8505 32 26.75 32ZM24.875 23.75L23.75 24.875L25.625 26.75L23.75 28.625L24.875 29.75L26.75 27.875L28.625 29.75L29.75 28.625L27.875 26.75L29.75 24.875L28.625 23.75L26.75 25.625L24.875 23.75Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24.875 23.75L23.75 24.875L25.625 26.75L23.75 28.625L24.875 29.75L26.75 27.875L28.625 29.75L29.75 28.625L27.875 26.75L29.75 24.875L28.625 23.75L26.75 25.625L24.875 23.75Z" class="svg-fg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.4116 5H26.5884L32 14.7409V21.75C31.4265 21.148 30.7505 20.6445 30 20.2675V17H2V25H19.7126C19.5737 25.5604 19.5 26.1466 19.5 26.75C19.5 26.8337 19.5014 26.917 19.5042 27H0V14.7409L5.4116 5ZM2.14396 15H29.856L25.4116 7H6.5884L2.14396 15Z" class="svg-bg"/>
  <path d="M8 21C8 22.1046 7.10457 23 6 23C4.89543 23 4 22.1046 4 21C4 19.8954 4.89543 19 6 19C7.10457 19 8 19.8954 8 21Z" class="svg-bg"/>
</svg>
`;
/**
 * IconHardwareHardDriveError is a generated icon component.
 */
let IconHardwareHardDriveError = IconHardwareHardDriveError_1 = class IconHardwareHardDriveError extends IconBaseElement {
    render() {
        return html `${IconHardwareHardDriveError_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconHardwareHardDriveError.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconHardwareHardDriveError = IconHardwareHardDriveError_1 = __decorate([
    customElement('zui-icon-hardware-hard-drive-error')
], IconHardwareHardDriveError);
export { IconHardwareHardDriveError };
